import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "complaint-list",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        complaintTypeId: "",
        complainedUserPhone: "",
        userPhone: "",
        adminId: "",
        status: "",
        id: this.$route.query.id
      },
      // 搜索表单
      adminList: [],
      complaintTypeList: [],
      remarkObj: {},
      remarkValue: "",
      remarkDialogVisible: false,
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getAdminList();
            _this.getComplaintTypeList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    goChatRecord: function goChatRecord(row) {
      window.open("#/im/chat/record?userId=".concat(row.user.id, "&otherId=").concat(row.complainedUser.id));
    },
    goUserList: function goUserList(phone) {
      window.open("#/user/list?phone=".concat(phone));
    },
    remarkDialog: function remarkDialog(row) {
      this.remarkObj = row;
      this.remarkValue = row.remark;
      this.remarkDialogVisible = true;
    },
    setComplaintRemark: function setComplaintRemark() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.setComplaintRemark({
                id: _this2.remarkObj.id,
                remark: _this2.remarkValue
              });
            case 1:
              res = _context2.v;
              _this2.remarkDialogVisible = false;
              _this2.$message.success("操作成功");
              _this2.getData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setFilter: function setFilter(row) {
      this.searchForm.complainedUserPhone = JSON.parse(JSON.stringify(row.complainedUser.phone));
      this.getData("search");
    },
    getComplaintTypeList: function getComplaintTypeList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getComplaintTypeList();
            case 1:
              res = _context3.v;
              _this3.complaintTypeList = res.data;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (type === "search") {
                _this4.searchForm.pn = 1;
              }
              _this4.tableLoading = true;
              _context4.n = 1;
              return _this4.$api.getComplaintListOld(_this4.searchForm);
            case 1:
              res = _context4.v;
              _this4.tableData = res.data.list;
              _this4.total = res.data.count;
              _this4.tableLoading = false;
              _this4.getUserScoreList(_this4.tableData);
              _this4.tableData = _this4.tableData.map(function (item) {
                var _item$user, _item$complainedUser;
                return _objectSpread(_objectSpread({}, item), {}, {
                  userId: (item === null || item === void 0 || (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.id) || '',
                  otherId: (item === null || item === void 0 || (_item$complainedUser = item.complainedUser) === null || _item$complainedUser === void 0 ? void 0 : _item$complainedUser.id) || ''
                });
              });
              _this4.getUserListByIds(_this4.tableData, "userId", "otherId");
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    //根据用户id获取雷达图信息
    getUserScoreList: function getUserScoreList(data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var userIds, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              userIds = [];
              data.forEach(function (item) {
                if (item.user.id || item.complainedUser.id) {
                  var userType = item.user.user_type;
                  var complainedUserType = item.complainedUser.user_type;
                  if (!userType) userIds.push(item.user.id);
                  if (!complainedUserType) userIds.push(item.complainedUser.id);
                }
              });
              userIds = _toConsumableArray(new Set(userIds));
              _context5.n = 1;
              return _this5.$api.queryUserScoreById({
                userIds: userIds
              });
            case 1:
              res = _context5.v;
              if (res && res.data.length) {
                _this5.tableData.forEach(function (item) {
                  var userScore = res.data.find(function (score) {
                    return score.userId === item.user.id;
                  });
                  var complainedUserScore = res.data.find(function (score) {
                    return score.userId === item.complainedUser.id;
                  });
                  _this5.$set(item.user, 'userScore', userScore || {});
                  _this5.$set(item.complainedUser, 'userScore', complainedUserScore || {});
                });
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getAdminList: function getAdminList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.getAdminUser({
                type: "all"
              });
            case 1:
              res = _context6.v;
              _this6.adminList = res.data;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    setComplaintStatus: function setComplaintStatus(id, status, user) {
      var _this7 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.setComplaintStatus({
                id: id,
                status: status
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();

              // 操作上报
              _this7.$operationLog.push({
                code: status == 1 ? "shelve" : "resolved",
                userId: user.id,
                operationType: "complain",
                detailBatchNo: id
              });
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    issueReward: function issueReward(row) {
      var _this8 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return _this8.$api.complaintIssueReward({
                id: row.id
              });
            case 1:
              _this8.$message.success("操作成功");
              _this8.getData();

              // 操作上报
              _this8.$operationLog.push({
                code: "reward",
                userId: row.user.id,
                operationType: "complain",
                detailBatchNo: row.id
              });
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))).catch(function () {});
    }
  }
};